import styled from 'styled-components';
import { rgba } from 'polished';

const imageDiameter = '4.5rem';

export const MenuContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: ${imageDiameter};
	height: ${`calc(${imageDiameter} + 2rem)`};

	label {
		margin: 0;
	}
`;

export const Container = styled.div`
	display: flex;
	align-items: flex-start;
	cursor: pointer;

	&:hover {
		background-color: ${({ theme }) => rgba(theme['midnight-lighten-10'], 0.5)};
	}
`;

export const ImageContainer = styled.div`
	a {
		display: block;
		padding: 1rem 0 1rem 2.5rem;
		min-width: ${imageDiameter};
	}
`;

export const Image = styled.div`
	border-radius: 50%;
	width: ${imageDiameter};
	height: ${imageDiameter};
	background-color: ${({ theme }) => rgba(theme['white'], 0.1)};
	background-image: url(${(props) => props.url});
	background-position: center center;
	background-repeat: no-repeat;
	background-size: cover;
`;

export const NotificationContainer = styled.div`
	a {
		display: flex;
		align-items: center;
		padding: 1rem 0;
		min-height: ${imageDiameter};
	}
`;

export const NotificationText = styled.p`
	flex: 1 1 0;
	margin: 0 1rem;
	color: ${({ theme, ...props }) => props.read ? rgba(theme['white'], 0.4) : theme['white']};
	font-weight: ${(props) => props.read ? '400' : '600'};
	font-size: 0.9rem;
	overflow-wrap: anywhere;
`;

export const DurationWrapper = styled.span`
	font-weight: 400;
	white-space: nowrap;

	svg {
		position: relative;
		top: -1px;
		margin-right: 0.25rem;
		width: 0.8rem;
		height: 0.8rem;
	}
`;
